<script lang="ts">
	import { onDestroy } from 'svelte';
	import { to_hh_mm_ss } from '../../helpers/utilities';
	import { calculate_timer } from '../../helpers/timer_helpers';

	export let device, status, settings;
	// bound from parent; all timers write here
	export let timerLabels: Record<string, any> = {};
	// unique key per timer instance (e.g. "gen1_main", "switch:100", etc.)
	export let timerKey: string;

	let isAddOnn;
	if (timerKey === 'switch:100') {
		isAddOnn = timerKey;
	}

	let [_, time] = calculate_timer(device, status, settings, isAddOnn);

	const tick = () => {
		const [, calcTime] = calculate_timer(device, status, settings, isAddOnn);
		// Use the server value only when it's lower than our local countdown.
		// During the drift window calcTime == duration every tick (math resolves to duration),
		// so we decrement manually until the real server value drops below our count.
		time = calcTime < time ? calcTime : Math.max(0, time - 1);
	};

	const clear = setInterval(tick, 1000);

	$: {
		if (time <= 0) {
			// Remove the label immediately when countdown expires, don't wait for cloud to clear timer
			delete timerLabels[timerKey];
		} else {
			timerLabels[timerKey] = {
				value: to_hh_mm_ss(time),
				icon: !isAddOnn ? 'fas fa-clock' : 'fak fa-solid-clock-circle-plus',
				type: 'primary',
			};
		}
		// force reactivity upstream (bind:timerLabels)
		timerLabels = { ...timerLabels };
	}

	$: if (time <= 0) clearInterval(clear);

	onDestroy(() => {
		clearInterval(clear);
		delete timerLabels[timerKey];
		timerLabels = { ...timerLabels };
	});
</script>

<!-- No UI here; this component only updates timerLabels -->
